import {DATASET_CATEGORIES} from "./filterBestDataset";

export const getCategoryFromRadioKey = (radioKey: string): string => {
  switch (radioKey) {
    case 'SW':
      return DATASET_CATEGORIES.WAVES;
    case 'HD':
      return DATASET_CATEGORIES.OCEAN;
    case 'Wind':
      return DATASET_CATEGORIES.ATMOSPHERE;
    default:
      return radioKey
  }
};
